import React, {useState, useContext, useEffect} from 'react';
import moment from "moment";
import __ from "lodash";
import { FormGroup, FormControl, Grid, TextField, InputLabel, IconButton, useTheme } from "@material-ui/core";
import { AttachFile } from "@material-ui/icons";

import SystemContext from "../../../SystemContext";
import { isHTML } from "../../../functions/TemplateHelperFunctions";
import StringToJSX from "../../../functions/StringToJsx";
import { DatePicker, Form, LabelledPaper, MaskedText} from '../../../controls';
import DocumentViewer from "../../Documents/DocumentViewer";
import MessageDetailsValidator from "../validators/MessageDetailsValidator";
import { useAddEmailMessage } from "../../../services/emailMessages";


const dateFormat = "DD/MM/YYYY";
const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}
const paperProps = {
  style: {
    backgroundColor: "#f8f8f8",
    boxShadow: 'none',
  }
}

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}


const MessageDetailsForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props
  }
  const classes = props.classes;

  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const [record, setRecord] = useState(props.record);
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });
  const [viewDocuments, setViewDocuments] = useState ({
    open: false,
    documentsToView: null,
  });

  // if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.companyUuid !== record.companyUuid) ) {
  //   setRecord(props.record);
  //   setEditing(false);
  // }

  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('MessageManagementList.rowSelected', (record)=> {
      setRecord(record);
      setEditing(false);
    });
  }

  useEffect(()=> {
    const open = async (record) => {
      setRecord(record);
      setEditing(false);
    }
    eventBus.bind("MessageManagementList.rowSelected", open);
    return () => {
      eventBus.unbind("MessageManagementList.rowSelected", open);
    }
  }, [record, eventBus]);

  const extraKeys = [];
  const handleUpdateMessage = useAddEmailMessage();

  const viewAttachments = (documents) => {
    //TODO: handle the attachment style of outbound CMS emails
    const documentsToView = [];
    if (documents && Array.isArray(documents)) {
      documents.forEach( document => {
        if (__.has(document, "success") && __.has(document, "attachmentUrl") && document.attachmentUrl) {
          const fileNameParts = document.attachmentFileName.split(".");
          const documentType = fileNameParts && Array.isArray(fileNameParts) && fileNameParts.length > 0 ? fileNameParts[fileNameParts.length - 1] : "";
          const documentDetails = {
            documentType: document.documentType,
            fileName: document.attachmentFileName,
            fileType: documentType,
            uri: document.attachmentUrl
          }
          documentsToView.push(documentDetails);
        }
      });
    }
    if (documentsToView.length > 0) {
      setViewDocuments({...setViewDocuments, open: true, documentsToView: documentsToView});
    }
  }

  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      {record ?
        <Form
          key="form"
          title={props.doNotDisplayTitle ? undefined : (record)=>{return `Message Details`}}
          message=""
          open={true}
          record={record}
          validator={editing?MessageDetailsValidator:null}
          top={"calc(100vh - 307px)"}
          formTitleStyle={{padding: "16px 16px"}}
          titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main, padding: "6px"}}
          formBodyStyle={{maxHeight: "calc(100vh - 280px)"}}
          buttonBarStyle={{width: "calc(100% - 20px)"}}
          buttons = {
            editing
              ?
                {
                  save: {icon: "check_circle", key: "Save", label: "Resubmit", color: "primary", disabled: (status)=>{return status.error}},
                  cancel: {icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
                }
            : props.canEdit
              ?
                {
                  edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
                }
              :
                {}
          }

          // validator={AddTripValidator}
          onChange={(state) => {
            if (state.buttonPressed === "edit" && props.canEdit) {
              setEditing(true);
            }
            if (state.buttonPressed === "cancel") {
              setEditing(false);
              setRecord(props.record);
            }
            if (state.buttonPressed === "save") {
              SystemData.toggleLoadingProgress(true);
              const record = {...__.omit(state.record, ["emailMessageUuid", "deletedAt", "createdAt", "updatedAt"]), messageSource: "RESUBMIT", originalMessage: state?.record?.originalMessage, processStatus: "NEW", error: null};
              handleUpdateMessage.mutate({
                extraKeys,
                record,
                postSuccess: () => {
                  setEditing(false);
                  SystemData.toggleLoadingProgress(false);
                  setAlert({ severity: "info", open: true, message: "Message Resubmitted for Processing", timeOut: 5 });
                },
                postError: (data) => {
                  SystemData.toggleLoadingProgress(false);
                  if (data.errorMessage) {
                    SystemData.alert("Error", `${data.errorMessage}`);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred resubmitting the message.`);
                  }
                }
              });
            } else {
            }
          }}
        >

          <Grid container checkChildren={true} spacing={1}>
            <Grid item xs={2} checkChildren={true}>
              <InputLabel id={`From-label`} style={{position: "relative", marginTop: 10}} >From:</InputLabel>
            </Grid>
            <Grid item xs={10} checkChildren={true} style={{marginLeft: -10}}>
              <MaskedText
                id="sender"
                readOnly={true}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <InputLabel id={`To-label`} style={{position: "relative", marginTop: 10}} >To:</InputLabel>
            </Grid>
            <Grid item xs={10} checkChildren={true} style={{marginLeft: -10}}>
              <MaskedText
                id="toAddress"
                readOnly={true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <InputLabel id={`Cc-label`} style={{position: "relative", marginTop: 10}} >CC:</InputLabel>
            </Grid>
            <Grid item xs={10} checkChildren={true} style={{marginLeft: -10}}>
              <MaskedText
                id="ccAddress"
                readOnly={true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <InputLabel id={`From-label`} style={{position: "relative", marginTop: 10}} >Subject:</InputLabel>
            </Grid>
            {record =>
              <Grid item xs={record.hasAttachments ? 9 : 10} checkChildren={true} style={{marginLeft: -10}}>
                <MaskedText
                  id="subject"
                  readOnly={true}
                  inputLabelProps={{shrink: true}}
                  fullWidth
                  mask={"x".repeat(400)}
                  maskChar={""}
                  alwaysShowMask={false}
                  formatChars={formatChars}
                />
              </Grid>
            }
            {record => {return (record.hasAttachments
              ?
                <Grid item xs={1} checkChildren={true} style={{marginTop: -15}}>
                  <IconButton
                    onClick={()=>{viewAttachments(record.attachments)}}
                  >
                    <AttachFile style={{height: 20, width: 20}} color="primary"/>
                  </IconButton>
                </Grid>
              :
                <></>
              )}
            }
            <Grid item xs={12} />
            <Grid item xs={12} />
            <Grid item xs={12} checkChildren={true} >
              {record =>
                {return (isHTML(record.textBody)
                  ?
                    <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                      <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                        <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                          <div style={{width: "100%", minHeight: 200, height: "calc(100vh - 750px)", maxHeight: "calc(100vh - 750px)", overflowY: "scroll"}}>
                            <StringToJSX domString={record.textBody}/>
                          </div>
                        </FormGroup>
                      </FormControl>
                    </LabelledPaper>
                  : record.textBody && typeof record.textBody === "object" ?
                    <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                      <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                        <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                          <pre style={{width: "100%", minHeight: 200, height: "calc(100vh - 750px)", maxHeight: "calc(100vh - 750px)", overflowY: "scroll"}}>
                            {JSON.stringify(record.textBody, null, 2)}
                          </pre>
                        </FormGroup>
                      </FormControl>
                    </LabelledPaper>
                  : isJson(record.textBody)?
                    <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                      <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                        <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                          <pre style={{width: "100%", minHeight: 200, height: "calc(100vh - 750px)", maxHeight: "calc(100vh - 750px)", overflowY: "scroll"}}>
                          {JSON.stringify(JSON.parse(record.textBody), null, 2)}
                          </pre>
                        </FormGroup>
                      </FormControl>
                    </LabelledPaper>
                  :
                    <TextField
                      id="textBody"
                      label={"Message"}
                      InputLabelProps={{ shrink: true }}
                      style={{width: "100%"}}
                      multiline
                      // minRows={1}
                      // maxRows={12}
                      inputProps={{readOnly:!editing, style:{height: "calc(100vh - 750px)", overflowY: "scroll", overflow: "hidden scroll"}}}
                      variant={"outlined"}
                      onChange={(value, props) => {
                        let updatedMessage = "";
                        if (value && value.length > 0) {
                          updatedMessage = value;
                        }
                        props.recordChange({...props.record, textBody: updatedMessage, originalMessage: props?.record?.textBody});
                      }}
                    />
                )}
              }
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={3} checkChildren={true}>
              {record =>
                <DatePicker
                  id={record.direction === "IN" ? "receivedAt": "sentAt"}
                  label={record.direction === "IN" ? "Received": "Sent"}
                  style={{width: 130, marginTop: -1,}}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  readOnly
                />
              }
            </Grid>
            <Grid item xs={9} checkChildren={true}>
              <MaskedText
                id="messageSource"
                label="Source"
                readOnly={true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="processStatus"
                label="Process Status"
                readOnly={true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={9} checkChildren={true}>
              <MaskedText
                id="error"
                label="Error"
                readOnly={true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(400)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
          </Grid>
        </Form>
        :<></>
      }
      {viewDocuments.open
        ?
        <DocumentViewer
          dialogStates={
            {showDialog: viewDocuments.open,
              title: `Documents Viewer for email`,
              record: viewDocuments.documentsToView[0]
            }
          }
          close={()=>{setViewDocuments({...viewDocuments, open: false})}}
          documents={viewDocuments.documentsToView}
        />
        :
        <></>
      }
    </div>
  );
}

export default MessageDetailsForm;
